/*
  Invitanda listing pop-up (pass 65, 2026-10-19). The owner: "Các phần other accessories chẳng hạn, khi ấn vào hiện lên
  listing để thấy rõ full listing cho khách chọn design", "ko phải trượt sang mà hiện lên, hoặc nếu khách dễ tính thì
  add luôn ko cần bấm hiện sản phẩm lên như hiện tại", "làm thêm tính năng hiện listing sản phẩm đủ để khách chọn được
  design khi upsale down sale bundle... chú ý testing kỹ".

  Wherever the store offers a product beside another one, a tap on its photo or its name pops up that product's
  listing over what she is looking at: a phone gets a sheet that rises from the bottom, a wider screen a box in the
  middle. Every quick control stays as it was (the menu and Add of a card, the ticks), so a fast buyer never opens it.
  Nothing loads a page: the listing comes from sections/mb-qv (the Section Rendering API), fetched when her finger
  touches the photo or the name, kept for the rest of the visit.

  Where it opens (a root element carries data-qv="<product handle>", and data-qv-mode when the button does more than
  add to the cart):
    .mbsl__card     a card of the sheet "Other accessories" / "For your table" (snippets/mb-acc-engine use shelf):
                    photo and name. Add to cart; the card then shows the - n + of that line (snippets/mb-sheet, event
                    mbqv:added), as after its own Add.
    .mbcs__card     a card of the cart's slider "Add to your table" (use slides, and the rack bag card of
                    snippets/mbc-cart-notes-core): photo and name. Add to cart; the cart is drawn in place.
    .mbc-form       the name bag form of the cart: its photo.
    label           a tick of the box Extras on a tile set page (snippets/mb-tier-panel, mode tick): its photo only (the
                    name still ticks the row, the quick way). "Add with your set" ticks the row with the design she
                    picked (no cart line of its own); the theme drawing the box again keeps her design.
    a.mbal__card    a card of "You may also like" (snippets/mb-also-like, snippets/mb-acc-engine use cards): the whole
                    card. A design card on a tile set page has mode two ("Choose this set": the row "A second set"
                    takes that design and back color, the event mbs:do of pass 62).
    li.mbc-cart__pick  a design of the cart's "Pick your second set" (mode pick2): photo and name. "Add this set",
                    in the size of the first set, at the second set price.
  Build your set keeps its cards as they are: a tap on a card there is the choice itself (the quick way).
  The pop-up: the photos (the chosen design first, then the product's other photos; a tap on a design shows its
  photo at once), the name, the price with the regular price struck, every option (designs and colors as their own
  photos with their full names, back colors as the chips of the set page, sizes as words), sold out marked and not
  selectable, three lines of the description with More, the note or the words to print with the spelling tick, the
  quantity where it makes sense, and one button. The button says what a choice is missing; it never adds with one
  missing. Close: the X, a tap outside, Escape, the back gesture of a phone (one history step, never a page).
  Way back: delete the line that loads this file in snippets/mb-cart-fix; the pages are then as in pass 64.
  pass 82 (2026-10-28, the owner's yes to "Pass 82 trên bản sao theme"; wiki page 40 §1.9 item 3): measurement only. Every
  opening sends ONE Shopify custom event, Shopify.analytics.publish('mb_qv_open', { variant_id, product_id, handle, mode,
  surface, loaded }), once the listing has been read (or could not be read: loaded false, variant_id the card's own or 0).
  variant_id is the choice the pop-up starts on; mode is the mode it opened in (two falls back to add, see ctxOf());
  surface is where she tapped: also_like, also_like_add (the card's Add), shelf, cart_slide, cart_bag, extras_tick,
  cart_pick2, api (QV.open). A custom pixel (a store setting, not in the theme) may pass it on to Meta as QuickView; it is
  never a ViewContent or a PageView, and this file calls no fbq. Nothing waits for it; a failure is swallowed (sent()).
*/
(function () {
  'use strict';
  if (window.__mbQv) return;
  if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal || !window.fetch || !window.Promise) return;
  var QV = window.__mbQv = { v: 65 };
  var doc = document, H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var root0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartPath = root0 + 'cart';
  var HEX = { 'Blue': '#0190E9', 'Green': '#327831', 'Ivory White': '#E3DCCA', 'Pink': '#EAA6CD', 'Purple': '#8488D1', 'Deep Red': '#BE273D', 'Yellow': '#EC9720' };
  var PZ = {
    ornament: { ph: 'Ava, 2026', hint: 'One name and the year, or for Mahj Squad the year and up to 6 names. Commas between, 12 letters a name at most.' },
    'name-tag': { ph: 'Ava, Mia, Zoe, Kim; Tuesday Mahj', hint: '1, 4 or 8 names, commas between, 10 letters each at most. For a club line on every tag, add a semicolon and up to 16 letters.' }
  };
  var TICK_PZ = 'I checked the spelling. Personalized items are final sale.';
  var TICK_BAG = 'I checked the spelling. Stitched bags are final sale.';
  // [what she taps, the element that holds the product, the mode]
  var SURF = [
    ['.mbsl__card[data-qv] .mbsl__ph, .mbsl__card[data-qv] .mbsl__name', '.mbsl__card[data-qv]', 'card'],
    ['.mbcs__card[data-qv] .mbcs__ph, .mbcs__card[data-qv] .mbcs__n', '.mbcs__card[data-qv]', 'add'],
    // pass 70: the Add of a card whose product has two or more choices (the mats) opens the listing to choose them
    ['.mbsl__card[data-qv] .mbsl__add[data-qv-open]', '.mbsl__card[data-qv]', 'card'],
    ['.mbcs__card[data-qv] .mbcs__add[data-qv-open]', '.mbcs__card[data-qv]', 'add'],
    ['.mbc-form[data-qv] .mbc-form__ph', '.mbc-form[data-qv]', 'add'],
    ['label[data-qv] .mbo__optimg', 'label[data-qv]', 'tick'],
    ['a.mbal__card[data-qv]', 'a.mbal__card[data-qv]', 'add'],
    ['li.mbc-cart__pick[data-qv] img, li.mbc-cart__pick[data-qv] strong', 'li.mbc-cart__pick[data-qv]', 'pick2']
  ];
  var cache = {}, dlg = null, st = null, pushed = false, popWait = null, busy = false, closing = false, lk = null;

  // ---------- helpers ----------
  function q(el, s) { return el ? el.querySelector(s) : null; }
  function qa(el, s) { return el ? Array.prototype.slice.call(el.querySelectorAll(s)) : []; }
  function txt(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function money(c) { c = Math.round(Number(c) || 0); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (x) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[x]; }); }
  function calm() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function sized(u, w) { return u ? String(u).replace(/([?&])width=\d+/, '$1width=' + w) : ''; }
  function srcset(u) { return [400, 700, 1000, 1400].map(function (w) { return sized(u, w) + ' ' + w + 'w'; }).join(', '); }
  // pass 67: the file of a photo is chosen here for the box it fills (its width times the screen's density, at most 2.5),
  // never by a srcset the browser reads its own way, so a photo read ahead is the very file the tap shows.
  var WS = [360, 540, 720, 900, 1080, 1440];
  function boxW() { var r = dlg && q(dlg, '[data-qv-row]'), w = (r && r.clientWidth) || Math.min(window.innerWidth, 480); return w * Math.min(window.devicePixelRatio || 1, 2.5); }
  function fit(u) { var need = boxW(), w = WS[WS.length - 1]; for (var i = 0; i < WS.length; i++) if (WS[i] >= need) { w = WS[i]; break; } return sized(u, w); }
  var got = {};
  function have(u) { return !!got[u]; }
  function fetchImg(u, cb) { if (got[u]) { if (cb) cb(); return; } var im = new Image(); im.decoding = 'async'; im.onload = function () { got[u] = 1; if (im.decode) im.decode().then(cb || null, cb || null); else if (cb) cb(); }; im.onerror = function () { if (cb) cb(); }; im.src = u; }
  function el(tag, cls, html) { var e = doc.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  function load(h) {
    if (!h) return Promise.reject(0);
    if (cache[h]) return cache[h];
    var p = fetch(root0 + 'products/' + encodeURIComponent(h) + '?sections=mb-qv', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) {
        var s = j && j['mb-qv'], m = typeof s === 'string' ? s.match(/<script type="application\/json" data-mbqv>([\s\S]*?)<\/script>/) : null;
        if (!m) throw 1;
        var d = JSON.parse(m[1]);
        if (!d || !d.vars || !d.vars.length) throw 2;
        return d;
      });
    cache[h] = p;
    p.catch(function () { if (cache[h] === p) delete cache[h]; });
    return p;
  }
  QV.load = load;

  // ---------- where she tapped ----------
  function find(t) {
    if (!t || !t.closest) return null;
    // pass 75: the Add of a "You may also like" set card opens the listing of its card, in the card's mode.
    var ad = t.closest('button.mbal__add[data-qv-add]');
    if (ad) {
      var cd = ad.parentNode ? ad.parentNode.querySelector('a.mbal__card[data-qv]') : null;
      if (cd) return { o: ad, r: cd, mode: cd.getAttribute('data-qv-mode') || 'add' };
    }
    for (var i = 0; i < SURF.length; i++) {
      var o = t.closest(SURF[i][0]);
      if (!o) continue;
      var r = o.closest(SURF[i][1]);
      if (!r || !r.getAttribute('data-qv')) continue;
      // A control inside the card keeps its own job (its menu, its Add, its note); the card itself may be the link.
      var ctl = t.closest('button, select, input, textarea, a[href]');
      if (ctl && ctl !== r && ctl !== o && r.contains(ctl)) continue; // pass 70: unless that control is the opener itself
      return { o: o, r: r, mode: r.getAttribute('data-qv-mode') || SURF[i][2] };
    }
    return null;
  }
  function imgOf(r, sel) { var im = q(r, sel); return im ? (im.currentSrc || im.getAttribute('src') || '') : ''; }
  function ctxOf(f) {
    var r = f.r, c = { r: r, o: f.o, mode: f.mode, h: r.getAttribute('data-qv'), vid: 0, img: '', name: '', label: r.getAttribute('data-qv-label') || '' };
    var cl = r.classList;
    if (cl.contains('mbsl__card')) {
      var s1 = q(r, '[data-mbs-var]'), a1 = q(r, '[data-mbs-add]');
      c.vid = Number((s1 && s1.value) || (a1 && a1.getAttribute('data-mbs-add')) || 0);
      c.img = imgOf(r, '[data-mbs-img]'); c.name = txt(q(r, '.mbsl__name'));
      var n1 = q(r, '[data-mbs-prop="Note"]'), z1 = q(r, '[data-mbs-pz]'), k1 = q(r, '[data-mbs-tick]');
      c.note = n1 ? n1.value : ''; c.pz = z1 ? z1.value : ''; c.tick = !!(k1 && k1.checked);
    } else if (cl.contains('mbcs__card') || cl.contains('mbc-form')) {
      var s2 = q(r, '[data-mbc-var]'), a2 = q(r, '[data-mbc-add]');
      c.vid = Number((s2 && s2.value) || (a2 && a2.getAttribute('data-mbc-add')) || 0);
      c.img = imgOf(r, '[data-mbc-img]'); c.name = txt(q(r, '.mbcs__n'));
      var nm2 = q(r, '[data-mbc-name]'), k2 = q(r, '[data-mbc-tick]');
      if (nm2) { c.bagName = nm2.value; c.tick = !!(k2 && k2.checked); }
    } else if (r.tagName === 'LABEL') {
      var inp = q(r, 'input[data-mbo-dice], input[data-mbo-trink]');
      c.inp = inp; c.vid = Number(inp ? inp.getAttribute('data-id') : 0);
      c.img = imgOf(r, '.mbo__optimg'); c.name = txt(q(r, '.mbo__optname'));
      c.label = c.label || 'Add with your set';
    } else if (cl.contains('mbal__card')) {
      c.img = imgOf(r, '.mbal__ph img'); c.name = txt(q(r, '.mbal__name'));
      // A second set only where the row "A second set" can take that design (else the card adds the set to the cart).
      var bx = c.mode === 'two' ? doc.querySelector('[data-mbo-twobox]') : null;
      if (c.mode === 'two' && !(bx && !bx.hidden && q(bx, '[data-mbo-twodesign] input[value="' + c.h.replace(/[^a-z0-9-]/gi, '') + '"]'))) c.mode = 'add';
      if (c.mode === 'two') {
        var pn = doc.querySelector('[data-c-off]');
        c.off = Number((pn && pn.getAttribute('data-c-off')) || r.getAttribute('data-qv-off') || 0);
        var g = doc.querySelector('[data-mbo-twobacks="' + c.h.replace(/[^a-z0-9-]/gi, '') + '"]'), ps = doc.querySelector('input[data-option-name="Size"]:checked');
        c.size = (g && g.getAttribute('data-mbo-twosz')) || (ps ? ps.value : '');
        var pc = doc.querySelector('input[data-option-name="Back color"]:checked');
        c.color = pc ? pc.value : '';
        c.label = c.label || 'Choose this set';
      }
    } else if (cl.contains('mbc-cart__pick')) {
      c.img = imgOf(r, 'img'); c.name = txt(q(r, 'strong'));
      c.size = r.getAttribute('data-mbc-sz') || '';
      var box = r.parentNode, bk = null;
      while (box && box !== doc.body && !(bk = q(box, '[data-mbc-backs]'))) box = box.parentNode;
      c.off = Number((bk && bk.getAttribute('data-mbc-off')) || 0);
      var ch = bk ? q(bk, '[data-mbc-back][aria-pressed="true"]') : null;
      c.color = ch ? ch.getAttribute('data-mbc-back') : txt(q(r, '[data-mbc-backtxt]')).replace(/ back$/, '');
      c.label = c.label || 'Add this set';
    }
    return c;
  }

  // ---------- the product ----------
  function isDefault(d) { return d.vars.length === 1 && d.opts.length === 1 && /^title$/i.test(d.opts[0].n); }
  function has(d, t) { return (d.tags || []).indexOf(t) >= 0; }
  function kindOf(d) {
    if (d.tpl === 'ornament' || d.tpl === 'name-tag') return 'pz';
    if (d.tpl === 'bag') return 'namebag';
    if (d.tpl === 'plain-bag') return 'plainbag';
    if (d.tpl === 'rack-bag') return 'rackbag';
    if (has(d, 'tile-set')) return 'set';
    return 'acc';
  }
  function optKind(d, i) {
    var n = d.opts[i].n;
    if (/back colou?r/i.test(n)) return 'chip';
    var seen = {}, ok = true;
    d.opts[i].v.forEach(function (val) {
      var m = 0;
      d.vars.forEach(function (v) { if (!m && v.o[i] === val && v.m) m = v.m; });
      if (!m || seen[m]) ok = false;
      seen[m] = 1;
    });
    return ok && d.opts[i].v.length > 1 ? 'photo' : 'text';
  }
  function match(d, sel) { for (var i = 0; i < d.vars.length; i++) { var v = d.vars[i], ok = true; for (var j = 0; j < sel.length; j++) if (v.o[j] !== sel[j]) { ok = false; break; } if (ok) return v; } return null; }
  function okFix(v) { return !st.fix || v.o[st.fix.i] === st.fix.v; }
  // The variant for a new value of option i: the same other choices when it can be bought, else the nearest that can.
  function resolve(d, i, val) {
    var want = st.sel.slice(); want[i] = val;
    var v = match(d, want);
    if (v && v.a && okFix(v)) return v;
    var best = null, bs = -1;
    d.vars.forEach(function (x) {
      if (!x.a || x.o[i] !== val || !okFix(x)) return;
      var s = 0; for (var j = 0; j < want.length; j++) if (j !== i && x.o[j] === want[j]) s += (want.length - j);
      if (s > bs) { bs = s; best = x; }
    });
    return best || v;
  }
  function anyAvail(d, i, val) { return d.vars.some(function (x) { return x.a && x.o[i] === val && okFix(x); }); }
  function cur() { return st && st.d ? match(st.d, st.sel) : null; }

  // ---------- the description ----------
  var KEEP = { P: 1, UL: 1, OL: 1, LI: 1, STRONG: 1, B: 1, EM: 1, I: 1, BR: 1, H3: 1, H4: 1, H5: 1, H6: 1 };
  function clean(html) {
    var box = doc.createElement('div');
    try {
      var src = new DOMParser().parseFromString('<div>' + String(html || '') + '</div>', 'text/html').body.firstChild;
      (function walk(from, to) {
        Array.prototype.forEach.call(from.childNodes, function (n) {
          if (n.nodeType === 3) { to.appendChild(doc.createTextNode(n.nodeValue)); return; }
          if (n.nodeType !== 1) return;
          var tg = n.tagName;
          if (/^(SCRIPT|STYLE|IMG|IFRAME|VIDEO|OBJECT|EMBED|TABLE|svg|SVG|BUTTON|FORM|INPUT|SELECT|TEXTAREA)$/.test(tg)) return;
          var out = KEEP[tg] ? doc.createElement(/^H[3-6]$/.test(tg) ? 'p' : tg.toLowerCase()) : doc.createElement('span');
          if (/^H[3-6]$/.test(tg)) out.className = 'mbqv__dh';
          walk(n, out);
          if (out.tagName === 'SPAN' && /^(DIV|SECTION)$/.test(tg)) { var pp = doc.createElement('p'); while (out.firstChild) pp.appendChild(out.firstChild); out = pp; }
          to.appendChild(out);
        });
      })(src, box);
    } catch (e) { box.textContent = String(html || '').replace(/<[^>]+>/g, ' '); }
    return box.innerHTML;
  }

  // ---------- the pop-up ----------
  var CSS = [
    '.mbqv{box-sizing:border-box;position:fixed;inset:auto 0 0 0;margin:0;width:100%;max-width:100%;max-height:92vh;max-height:92dvh;padding:0;border:0;border-radius:16px 16px 0 0;background:#fff;color:#1F1B24;overflow:hidden;box-shadow:0 -8px 32px rgb(31 27 36/.25);font-size:1rem;line-height:1.5}',
    '.mbqv[open]{display:flex;flex-direction:column}',
    '.mbqv::backdrop{background:rgb(31 27 36/.5)}',
    '.mbqv *,.mbqv *::before,.mbqv *::after{box-sizing:border-box}',
    '.mbqv__x{position:absolute;top:8px;right:8px;z-index:4;display:grid;place-items:center;width:44px;height:44px;margin:0;padding:0;border:0;border-radius:50%;background:rgb(255 255 255/.94);color:#1F1B24;box-shadow:0 1px 4px rgb(0 0 0/.18);cursor:pointer}',
    '.mbqv__body{flex:1 1 auto;min-height:0;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}',
    '.mbqv__gal{position:relative;min-width:0;background:#F3EDE2}',
    '.mbqv__row{display:flex;overflow-x:auto;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scrollbar-width:none}',
    '.mbqv__row::-webkit-scrollbar{display:none}',
    '.mbqv__ph{flex:0 0 100%;height:min(100vw,50vh);height:min(100vw,50dvh);scroll-snap-align:start;background:#F3EDE2 center/cover no-repeat}',
    '.mbqv__ph img{display:block;width:100%;height:100%;object-fit:contain;opacity:0;transition:opacity .16s ease-out}',
    '.mbqv__ph img.is-in{opacity:1}',
    '.mbqv__dots{position:absolute;left:0;right:0;bottom:8px;display:flex;justify-content:center;gap:6px;pointer-events:none}',
    '.mbqv__dots span{width:7px;height:7px;border-radius:50%;background:rgb(31 27 36/.28)}',
    '.mbqv__dots span.is-on{background:#1F1B24}',
    '.mbqv__thumbs{display:none}',
    '.mbqv__thumb{flex:none;width:56px;height:56px;margin:0;padding:0;border:1px solid #E6DCCB;border-radius:8px;background:#F3EDE2;overflow:hidden;cursor:pointer}',
    '.mbqv__thumb img{display:block;width:100%;height:100%;object-fit:cover}',
    '.mbqv__thumb.is-on{border-color:#7A4E12;box-shadow:inset 0 0 0 1px #7A4E12}',
    '.mbqv__arr{position:absolute;top:calc(50% - 22px);z-index:2;display:none;place-items:center;width:44px;height:44px;margin:0;padding:0;border:0;border-radius:50%;background:rgb(255 255 255/.94);color:#1F1B24;box-shadow:0 1px 3px rgb(0 0 0/.2);cursor:pointer}',
    '.mbqv__arr--p{left:10px}.mbqv__arr--n{right:10px}',
    '@media (hover:hover) and (pointer:fine){.mbqv__gal--many .mbqv__arr{display:grid}}',
    '.mbqv__txt{display:grid;gap:12px;min-width:0;align-content:start;padding:16px 16px 20px}',
    '.mbqv__hb{display:grid;gap:2px}',
    '.mbqv__h{margin:0;font-family:var(--font-heading--family,inherit);font-size:1.25rem;font-weight:700;line-height:1.25;letter-spacing:normal;text-transform:none;color:#1F1B24}',
    '.mbqv__h:focus{outline:0}',
    '.mbqv__tl{margin:0;font-size:.9375rem;line-height:1.4;color:#4a4a4a}',
    '.mbqv__pr{margin:0;font-size:1.125rem;font-weight:700;line-height:1.3;font-variant-numeric:tabular-nums}',
    '.mbqv__pr s{margin-left:8px;font-size:.9375rem;font-weight:400;color:#5f5a66}',
    '.mbqv__sz{display:block;margin-top:2px;font-size:.9375rem;font-weight:400;color:#4a4a4a}',
    '.mbqv__opt{display:grid;gap:8px;min-width:0;margin:0;padding:0;border:0}',
    '.mbqv__optl{margin:0;font-weight:700;line-height:1.4}',
    '.mbqv__optl span{font-weight:400}',
    '.mbqv__sws{display:grid;grid-template-columns:repeat(auto-fill,minmax(70px,1fr));gap:12px 8px}',
    '.mbqv__sw{display:grid;align-content:start;justify-items:center;gap:5px;min-width:0;margin:0;padding:0;border:0;background:none;color:inherit;font:inherit;text-align:center;cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '.mbqv__swp{display:block;width:100%;aspect-ratio:1/1;border:1px solid #E6DCCB;border-radius:10px;background:#F3EDE2;overflow:hidden}',
    '.mbqv__swp img{display:block;width:100%;height:100%;object-fit:cover}',
    '.mbqv__sw[aria-pressed="true"] .mbqv__swp{border-color:#fff;box-shadow:0 0 0 2px #7A4E12}',
    '.mbqv__swn{display:block;max-width:100%;font-size:.8125rem;line-height:1.3;overflow-wrap:normal;word-break:normal;-webkit-hyphens:auto;hyphens:auto}',
    '.mbqv__sw[aria-pressed="true"] .mbqv__swn{font-weight:700}',
    '.mbqv__swo{display:block;font-size:.75rem;line-height:1.3;color:#8a1f11}',
    '.mbqv__sw:disabled{cursor:default}',
    '.mbqv__sw:disabled .mbqv__swp{opacity:.45;background-image:linear-gradient(to top right,transparent calc(50% - 1px),#8a1f11 calc(50% - 1px),#8a1f11 calc(50% + 1px),transparent calc(50% + 1px))}',
    '.mbqv__chips{display:flex;flex-wrap:wrap;gap:10px;padding:4px}',
    '.mbqv__chip{position:relative;width:34px;height:34px;margin:0;padding:0;border:1px solid rgb(0 0 0/.22);border-radius:7px;background:var(--c,#D9D2C3);cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '.mbqv__chip::after{content:"";position:absolute;inset:-6px}',
    '.mbqv__chip[aria-pressed="true"]{box-shadow:0 0 0 2px #fff,0 0 0 4px #7A4E12}',
    '.mbqv__chip:disabled{opacity:.35;cursor:default}',
    '.mbqv__txs{display:grid;grid-template-columns:repeat(auto-fill,minmax(96px,1fr));gap:8px}',
    '.mbqv__tx{display:grid;justify-items:center;align-content:center;gap:1px;min-height:48px;margin:0;padding:6px 8px;border:1px solid #B9B0A3;border-radius:8px;background:#fff;color:#1F1B24;font:inherit;line-height:1.25;text-align:center;cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '.mbqv__tx[aria-pressed="true"]{border-color:#7A4E12;box-shadow:inset 0 0 0 1px #7A4E12}',
    '.mbqv__tx:disabled{opacity:.45;cursor:default;text-decoration:line-through}',
    '.mbqv__txn{font-size:1rem;font-weight:700}',
    '.mbqv__txm{font-size:.8125rem;color:#4a4a4a}',
    '.mbqv__drow{min-width:0;margin:4px 0 0;border-top:1px solid #1F1B24;border-bottom:1px solid #1F1B24}',
    '.mbqv__dsum{display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:48px;padding:10px 0;list-style:none;cursor:pointer;font-family:var(--font-h6--family,var(--font-heading--family,inherit));font-size:.9375rem;font-weight:700;line-height:1.3;color:#1F1B24;-webkit-tap-highlight-color:transparent}',
    '.mbqv__dsum::-webkit-details-marker{display:none}.mbqv__dsum::marker{content:""}',
    '.mbqv__dsum:focus-visible{outline:3px solid #0b57d0;outline-offset:2px}',
    '.mbqv__di{flex:none;display:block}.mbqv__drow[open] .mbqv__dv{display:none}',
    '.mbqv__dtx{padding:0 0 14px;font-size:.9375rem;line-height:1.55;color:#2f2a35;overflow-wrap:break-word}',
    '.mbqv__dtx p,.mbqv__dtx ul,.mbqv__dtx ol{margin:0 0 8px}',
    '.mbqv__dtx ul,.mbqv__dtx ol{padding-left:1.2rem}',
    '.mbqv__dtx li{margin:0 0 2px}',
    '.mbqv__dtx .mbqv__dh{font-weight:700}',
    '.mbqv__more-unused{justify-self:start;min-height:32px;margin:0;padding:0;border:0;background:none;color:#1F1B24;font:inherit;font-size:.9375rem;font-weight:700;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.mbqv__flds{display:grid;gap:10px;min-width:0}',
    '.mbqv__f{display:grid;gap:6px;min-width:0;margin:0}',
    '.mbqv__fl{font-weight:700;line-height:1.4}',
    '.mbqv__inw{position:relative;display:block}',
    '.mbqv__in{width:100%;min-height:48px;margin:0;padding:10px 12px;border:1px solid #B9B0A3;border-radius:8px;background:#fff;color:#1F1B24;font:inherit;font-size:max(16px,1rem);line-height:1.4}',
    '.mbqv__in:focus{outline:none;border-color:#7A4E12;box-shadow:inset 0 0 0 1px #7A4E12}',
    '.mbqv__in[aria-invalid="true"]{border-color:#8a1f11;box-shadow:inset 0 0 0 1px #8a1f11}',
    '.mbqv__in--cnt{padding-right:64px}',
    '.mbqv__cnt{position:absolute;top:0;right:12px;display:flex;align-items:center;height:48px;color:#4a4a4a;font-variant-numeric:tabular-nums;pointer-events:none}',
    '.mbqv__hint{font-size:.875rem;line-height:1.45;color:#4a4a4a}',
    '.mbqv__tick{display:flex;align-items:flex-start;gap:10px;min-height:44px;margin:0;padding:4px 0;font-size:.9375rem;line-height:1.45;cursor:pointer}',
    '.mbqv__tick input{flex:none;width:22px;height:22px;margin:1px 0 0;accent-color:#2B1D3A}',
    '.mbqv__nt{justify-self:start;min-height:32px;margin:0;padding:0;border:0;background:none;color:#4a4a4a;font:inherit;font-size:.9375rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.mbqv__ferr{margin:0;font-size:.9375rem;font-weight:700;line-height:1.4;color:#8a1f11}',
    '.mbqv__ferr[hidden],.mbqv__err[hidden],.mbqv [hidden]{display:none !important}',
    '.mbqv__bar{flex:none;display:grid;gap:8px;padding:12px 16px;padding-bottom:max(12px,env(safe-area-inset-bottom));border-top:1px solid #E6DCCB;background:#fff}',
    '.mbqv__err{margin:0;font-size:.9375rem;font-weight:700;line-height:1.4;color:#8a1f11}',
    '.mbqv__act{display:flex;align-items:stretch;gap:10px}',
    '.mbqv__qty{flex:none;display:inline-flex;align-items:center;border:1.5px solid #1F1B24;border-radius:40px;min-height:52px}',
    '.mbqv__qb{width:44px;height:48px;margin:0;padding:0;border:0;border-radius:40px;background:none;color:#1F1B24;font:inherit;font-size:1.25rem;line-height:1;cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '.mbqv__qb:disabled{opacity:.35;cursor:default}',
    '.mbqv__qn{min-width:1.6em;text-align:center;font-weight:700;font-variant-numeric:tabular-nums}',
    '.mbqv__go.mbqv__go{flex:1 1 auto;display:flex;align-items:center;justify-content:center;gap:8px;min-width:0;min-height:52px;margin:0;white-space:normal;text-align:center}',
    '.mbqv__go[aria-busy="true"]{opacity:.65}',
    '.mbqv__go.is-done{background:#1d5b2c;border-color:#1d5b2c;color:#fff}',
    '.mbqv__go:disabled{cursor:default}',
    '.mbqv__load{display:grid;gap:10px;padding:4px 0}',
    '.mbqv__load span{display:block;height:14px;border-radius:7px;background:linear-gradient(90deg,#F3EDE2 25%,#FAF7F2 50%,#F3EDE2 75%);background-size:200% 100%;animation:mbqv-sh 1.1s linear infinite}',
    '.mbqv__load span:nth-child(2){width:70%}.mbqv__load span:nth-child(3){width:85%}',
    '@keyframes mbqv-sh{from{background-position:100% 0}to{background-position:-100% 0}}',
    '.mbqv__sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip-path:inset(50%);white-space:nowrap}',
    '.mbqv button:focus-visible,.mbqv a:focus-visible{outline:3px solid #0b57d0;outline-offset:2px}',
    '.mbqv .mbqv__tick input:focus-visible{outline:3px solid #0b57d0;outline-offset:2px}',
    '[data-qv] .mbsl__ph,[data-qv] .mbsl__name,[data-qv] .mbcs__ph,[data-qv] .mbcs__n,[data-qv] .mbc-form__ph,li[data-qv] img,li[data-qv] strong{cursor:pointer}',
    'label[data-qv] .mbo__optimg{cursor:zoom-in}',
    '@media (hover:hover) and (pointer:fine){[data-qv] .mbsl__name:hover,[data-qv] .mbcs__n:hover,li[data-qv] strong:hover{text-decoration:underline;text-underline-offset:3px}}',
    '@media screen and (max-width:359px){.mbqv__gop{display:none}.mbqv__qb{width:38px}.mbqv__chips{gap:8px;padding:4px 2px}.mbqv__chip{width:32px;height:32px}}',
    '@media screen and (min-width:750px){.mbqv{inset:0;margin:auto;width:min(52rem,94vw);max-height:min(88vh,48rem);max-height:min(88dvh,48rem);border-radius:14px;box-shadow:0 12px 40px rgb(31 27 36/.28)}.mbqv__body{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);align-items:start}.mbqv__gal{position:sticky;top:0;background:#fff}.mbqv__row{background:#F3EDE2}.mbqv__ph{height:auto;aspect-ratio:1/1}.mbqv__gal--many .mbqv__dots{display:none}.mbqv__thumbs{display:flex;gap:8px;padding:10px 12px 12px;overflow-x:auto;scrollbar-width:none}.mbqv__thumbs::-webkit-scrollbar{display:none}.mbqv__arr{top:calc(50% - 22px - 39px)}.mbqv__txt{padding:52px 24px 20px}.mbqv__bar{grid-template-columns:minmax(0,1fr) minmax(0,1fr);column-gap:0;padding:12px 24px 16px}.mbqv__bar>*{grid-column:2;padding-inline:24px 0}}',
    '@media screen and (min-width:990px){.mbqv{width:min(60rem,92vw)}.mbqv__txt{padding:56px 28px 24px}.mbqv__bar>*{padding-inline:28px 0}.mbqv__sws{grid-template-columns:repeat(auto-fill,minmax(68px,1fr))}}',
    '@media (prefers-reduced-motion:no-preference){.mbqv[open]{animation:mbqv-up .24s cubic-bezier(.2,.8,.2,1)}.mbqv[open]::backdrop{animation:mbqv-fade .2s ease-out}.mbqv.is-out{animation:mbqv-down .18s ease-in forwards}.mbqv.is-out::backdrop{animation:mbqv-fade .18s ease-in reverse forwards}@keyframes mbqv-up{from{transform:translateY(100%)}to{transform:none}}@keyframes mbqv-down{from{transform:none}to{transform:translateY(100%)}}@keyframes mbqv-fade{from{opacity:0}to{opacity:1}}}',
    '@media (prefers-reduced-motion:no-preference) and (min-width:750px){.mbqv[open]{animation:mbqv-in .18s ease-out}.mbqv.is-out{animation:mbqv-out .14s ease-in forwards}@keyframes mbqv-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}@keyframes mbqv-out{from{opacity:1}to{opacity:0;transform:translateY(6px)}}}',
    '@media (forced-colors:active){.mbqv{border:1px solid CanvasText}.mbqv__chip,.mbqv__swp{forced-color-adjust:none}}'
  ].join('\n');
  var ICON_X = '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M3 3l12 12M15 3L3 15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_L = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M9 2L4 7l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_R = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M5 2l5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_OK = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3.2L13 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';

  // The look is put in once the page is read, so the photos and names that open the pop-up show their pointer at once.
  function css() { if (!doc.getElementById('mbqv-css') && doc.head) { var s = el('style'); s.id = 'mbqv-css'; s.textContent = CSS; doc.head.appendChild(s); } }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', css); else css();
  function build() {
    if (dlg && dlg.isConnected) return dlg;
    css();
    dlg = el('dialog', 'mbqv');
    dlg.id = 'mb-qv';
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-labelledby', 'mbqv-h');
    dlg.innerHTML = '<button type="button" class="mbqv__x" data-qv-x aria-label="Close">' + ICON_X + '</button><div class="mbqv__body" data-qv-body></div><div class="mbqv__bar" data-qv-bar><p class="mbqv__err" data-qv-err role="alert" hidden></p><div class="mbqv__act"></div></div><p class="mbqv__sr" role="status" data-qv-live></p>';
    doc.body.appendChild(dlg);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close('esc'); });
    dlg.addEventListener('close', cleanup);
    dlg.addEventListener('click', inside);
    dlg.addEventListener('input', field);
    dlg.addEventListener('change', field);
    dlg.addEventListener('keydown', function (e) { var t = e.target; if (e.key === 'Enter' && t && t.classList && t.classList.contains('mbqv__in')) { e.preventDefault(); t.blur(); } });
    return dlg;
  }
  function live(t) { var l = q(dlg, '[data-qv-live]'); if (l) l.textContent = t; }

  // ---------- open ----------
  function open(c) {
    if (busy || closing) return;
    if (popWait) { var c0 = c; popWait.then(function () { open(c0); }); return; }
    build();
    st = { c: c, d: null, sel: [], qty: 1, fix: null, kind: '', done: false };
    var body = q(dlg, '[data-qv-body]');
    body.innerHTML = '';
    // What she tapped, at once: its photo, its name; the rest comes in a moment.
    var gal = el('div', 'mbqv__gal'), row = el('div', 'mbqv__row'), ph = el('div', 'mbqv__ph');
    if (c.img) { var im = el('img'); im.alt = ''; im.src = c.img; im.className = 'is-in'; ph.appendChild(im); }
    row.appendChild(ph); gal.appendChild(row); body.appendChild(gal);
    var t = el('div', 'mbqv__txt');
    t.innerHTML = '<div class="mbqv__hb"><h2 class="mbqv__h" id="mbqv-h" tabindex="-1">' + esc(c.name || '') + '</h2></div><div class="mbqv__load" aria-hidden="true"><span></span><span></span><span></span></div>';
    body.appendChild(t);
    q(dlg, '[data-qv-err]').hidden = true;
    q(dlg, '.mbqv__act').innerHTML = '<button type="button" class="button mbqv__go" data-qv-go disabled>' + esc(c.label || 'Add to cart') + '</button>';
    dlg.classList.remove('is-out');
    lock();
    dlg.showModal();
    hpush();
    try { q(dlg, '#mbqv-h').focus({ preventScroll: true }); } catch (e) {}
    body.scrollTop = 0;
    // pass 82: sent() after the drawing (finally: the event goes even if drawing throws, and the error stays as before).
    load(c.h).then(function (d) { try { if (st && st.c === c && dlg.open) draw(d); } finally { sent(c, d); } }, function () { try { if (st && st.c === c && dlg.open) failed(); } finally { sent(c, null); } });
  }
  // pass 82 (2026-10-28): the event mb_qv_open (header). One per opening, small, never blocks, never throws.
  var SURF_N = [['mbal__card', 'also_like'], ['mbsl__card', 'shelf'], ['mbcs__card', 'cart_slide'], ['mbc-form', 'cart_bag'], ['mbc-cart__pick', 'cart_pick2']];
  function surf(c) {
    var r = c.r, i;
    if (!r || !r.classList) return 'other';
    if (r.tagName === 'LABEL') return 'extras_tick';
    for (i = 0; i < SURF_N.length; i++) if (r.classList.contains(SURF_N[i][0])) return SURF_N[i][1] + (i === 0 && c.o && c.o.matches && c.o.matches('button.mbal__add') ? '_add' : '');
    return r === doc.body ? 'api' : 'other';
  }
  function sent(c, d) {
    try {
      var a = window.Shopify && window.Shopify.analytics, vid = Number(c.vid) || 0, v = null, i;
      if (!a || typeof a.publish !== 'function') return;
      if (d && st && st.c === c && st.d === d) v = cur();
      if (v) vid = v.id;
      else if (d && !vid) for (i = 0; i < d.vars.length; i++) if (d.vars[i].a) { vid = d.vars[i].id; break; }
      a.publish('mb_qv_open', { variant_id: vid, product_id: d ? Number(d.id) || 0 : 0, handle: String(c.h || ''), mode: String(c.mode || ''), surface: surf(c), loaded: !!d });
    } catch (e) {}
  }
  function failed() {
    var c = st.c;
    // A card of "You may also like" still has its sheet of before: it opens that one instead.
    if (c.r.matches('a.mbal__card[data-mbs-open]') && !c.r.__qvBack) {
      closeNow();
      c.r.__qvBack = true;
      setTimeout(function () { try { c.r.click(); } finally { c.r.__qvBack = false; } }, 30);
      return;
    }
    var t = q(dlg, '.mbqv__txt');
    var ld = q(t, '.mbqv__load'); if (ld) ld.remove();
    var p = el('p', 'mbqv__ferr', 'We could not load this product. Please try again.');
    t.appendChild(p);
    var b = q(dlg, '[data-qv-go]');
    b.disabled = false; b.textContent = 'Try again'; b.setAttribute('data-qv-retry', '');
  }

  // ---------- draw the listing ----------
  function draw(d) {
    var c = st.c;
    st.d = d; st.kind = kindOf(d);
    // The choice to start on: the one the row or card holds, else the first that can be bought.
    var v0 = null;
    d.vars.forEach(function (v) { if (!v0 && c.vid && v.id === c.vid) v0 = v; });
    st.fix = null;
    if ((c.mode === 'two' || c.mode === 'pick2') && c.size) {
      var si = -1; d.opts.forEach(function (o, i) { if (/^size$/i.test(o.n) && o.v.indexOf(c.size) >= 0) si = i; });
      if (si >= 0) st.fix = { i: si, v: c.size };
    }
    if (c.color && !v0) {
      var bi = -1; d.opts.forEach(function (o, i) { if (/back colou?r/i.test(o.n)) bi = i; });
      if (bi >= 0) d.vars.forEach(function (v) { if (!v0 && v.a && v.o[bi] === c.color && okFix(v)) v0 = v; });
    }
    if (v0 && (!v0.a || !okFix(v0))) v0 = null;
    if (!v0) d.vars.forEach(function (v) { if (!v0 && v.a && okFix(v)) v0 = v; });
    if (!v0) v0 = d.vars[0];
    st.sel = v0.o.slice();
    if (st.fix) st.sel[st.fix.i] = st.fix.v;
    var body = q(dlg, '[data-qv-body]'), keepSrc = c.img;
    body.innerHTML = '';
    body.appendChild(gallery(d, keepSrc));
    var t = el('div', 'mbqv__txt');
    var hb = el('div', 'mbqv__hb');
    hb.innerHTML = '<h2 class="mbqv__h" id="mbqv-h" tabindex="-1">' + esc(d.hd || d.t) + '</h2>' + (d.tl && st.kind !== 'set' ? '<p class="mbqv__tl">' + esc(d.tl) + '</p>' : '');
    t.appendChild(hb);
    t.appendChild(el('p', 'mbqv__pr'));
    // The options in the product's order; a tile set shows its size first, as its page does.
    if (!isDefault(d)) {
      var order = d.opts.map(function (o, i) { return i; });
      if (st.kind === 'set') order.sort(function (a, b) { return (/^size$/i.test(d.opts[b].n) ? 1 : 0) - (/^size$/i.test(d.opts[a].n) ? 1 : 0); });
      order.forEach(function (i) { if (st.fix && st.fix.i === i) return; t.appendChild(optBlock(d, i)); });
    }
    var fl = fields(d);
    if (fl) t.appendChild(fl);
    // pass 67 (the owner, 2026-10-20: "chỗ hiện more (description) ... chưa biết làm sao cho hợp lý"): the description is
    // one closed row at the end, drawn like the rows of the product page; it opens in place with the whole text. The
    // buy part (name, price, designs, quantity, the button) has no sentence cut in the middle any more.
    if (d.desc) {
      var ds = el('details', 'mbqv__drow');
      ds.innerHTML = '<summary class="mbqv__dsum"><span>Description</span><svg class="mbqv__di" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false"><path d="M2.75 7h8.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/><path class="mbqv__dv" d="M7 2.75v8.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg></summary>';
      ds.appendChild(el('div', 'mbqv__dtx', clean(d.desc)));
      t.appendChild(ds);
    }
    body.appendChild(t);
    // The bar: the quantity where it makes sense, and the one button.
    var act = q(dlg, '.mbqv__act');
    act.innerHTML = '';
    if ((c.mode === 'add' || c.mode === 'card') && st.kind !== 'set') {
      var qy = el('span', 'mbqv__qty');
      qy.innerHTML = '<button type="button" class="mbqv__qb" data-qv-q="-1" aria-label="One less">−</button><span class="mbqv__qn" data-qv-qn aria-live="polite">1</span><button type="button" class="mbqv__qb" data-qv-q="1" aria-label="One more">+</button>';
      act.appendChild(qy);
    }
    var go = el('button', 'button mbqv__go'); go.type = 'button'; go.setAttribute('data-qv-go', '');
    act.appendChild(go);
    paint(false);
    // Each design's small photo, ready for the moment she taps a chip or a size (the photo then changes at once).
    var seen = {}, nPre = 0;
    d.vars.forEach(function (v) { if (v.th && !seen[v.th] && nPre < 24) { seen[v.th] = 1; nPre++; var im = new Image(); im.decoding = 'async'; im.src = v.th; } });
    // pass 67: then every design's photo at a medium size (two at a time, once the first photo is in), so a design tap
    // shows a real photo at once; on a connection that saves data, only the small ones.
    var save = false; try { save = !!(navigator.connection && navigator.connection.saveData); } catch (x) {}
    if (!save) {
      var qd = [], seen2 = {}, cur0 = cur(), first = q(dlg, '[data-qv-row] img');
      d.vars.forEach(function (v) { var u = v.l ? sized(v.l, 540) : ''; if (u && !seen2[u] && qd.length < 16) { seen2[u] = 1; qd.push(u); } });
      var runQ = function () { var next = function () { if (!st || st.d !== d || !qd.length) return; if (window.__mbQvHold) { setTimeout(next, 150); return; } var u = qd.shift(); fetchImg(u, next); }; next(); next(); };
      if (first && !(first.complete && first.naturalWidth)) first.addEventListener('load', runQ, { once: true }); else runQ();
    }
    try { q(dlg, '#mbqv-h').focus({ preventScroll: true }); } catch (e) {}
  }
  // The photos: the chosen design's photo (the color slide), the product's other photos; nine at most. When the first
  // photo of the product is not a design's own (a tile set), it stays first, as in the set sheets of pass 62.
  function gallery(d, keepSrc) {
    var vm = {}, any = false;
    d.vars.forEach(function (v) { if (v.m) { vm[v.m] = 1; any = true; } });
    var others = d.media.filter(function (m) { return !vm[m.id]; }), v = cur(), cslide = null, slides = [];
    if (any) {
      var cm = v && v.m ? v.m : 0, src = v && v.l ? v.l : '';
      if (!src) d.vars.forEach(function (x) { if (!src && x.l) { src = x.l; cm = x.m; } });
      cslide = { id: cm, l: src, a: '', c: true };
    }
    var featV = !!vm[d.feat];
    if (cslide && (featV || !others.length)) slides.push(cslide);
    others.forEach(function (m, i) { if (slides.length >= 9) return; slides.push(m); if (i === 0 && cslide && !featV) slides.push(cslide); });
    if (!slides.length && d.media.length) slides.push(d.media[0]);
    st.slides = slides;
    var gal = el('div', 'mbqv__gal' + (slides.length > 1 ? ' mbqv__gal--many' : '')), row = el('div', 'mbqv__row');
    row.setAttribute('data-qv-row', '');
    slides.forEach(function (m, i) {
      var ph = el('div', 'mbqv__ph'), im = el('img');
      if (m.c) ph.setAttribute('data-qv-cslide', '');
      if (i === 0 && keepSrc) ph.style.backgroundImage = 'url("' + keepSrc.replace(/"/g, '%22') + '")';
      im.alt = m.a || (d.hd || '');
      im.decoding = 'async';
      im.loading = i === 0 ? 'eager' : 'lazy';
      // The photo she tapped stays under the new one until it has faded in (no blank frame).
      im.addEventListener('load', function () { got[im.getAttribute('src')] = 1; im.classList.add('is-in'); if (ph.style.backgroundImage) setTimeout(function () { ph.style.backgroundImage = ''; }, 260); });
      im.src = fit(m.l);
      if (im.complete && im.naturalWidth) im.classList.add('is-in');
      ph.appendChild(im); row.appendChild(ph);
    });
    gal.appendChild(row);
    if (slides.length > 1) {
      var dots = el('div', 'mbqv__dots');
      slides.forEach(function (m, i) { dots.appendChild(el('span', i === 0 ? 'is-on' : '')); });
      gal.appendChild(dots);
      // From 750 px the small photos stand under the big one (the set sheets of pass 62); a tap shows that photo.
      var ths = el('div', 'mbqv__thumbs');
      slides.forEach(function (m, i) {
        var b = el('button', 'mbqv__thumb' + (i === 0 ? ' is-on' : '')), src = m.c ? ((cur() && cur().th) || m.th || '') : (m.th || '');
        b.type = 'button'; b.setAttribute('data-qv-thumb', String(i)); b.setAttribute('aria-label', 'Photo ' + (i + 1));
        if (m.c) b.setAttribute('data-qv-cthumb', '');
        b.innerHTML = '<img src="' + esc(src) + '" alt="" width="56" height="56" loading="lazy" decoding="async">';
        ths.appendChild(b);
      });
      gal.appendChild(ths);
      gal.insertAdjacentHTML('beforeend', '<button type="button" class="mbqv__arr mbqv__arr--p" data-qv-step="-1" aria-label="Previous photo">' + ICON_L + '</button><button type="button" class="mbqv__arr mbqv__arr--n" data-qv-step="1" aria-label="Next photo">' + ICON_R + '</button>');
      var tm = 0;
      row.addEventListener('scroll', function () {
        if (tm) return;
        tm = requestAnimationFrame(function () { tm = 0; var k = Math.round(row.scrollLeft / Math.max(1, row.clientWidth)); qa(dots, 'span').forEach(function (s, i) { s.classList.toggle('is-on', i === k); }); qa(ths, '.mbqv__thumb').forEach(function (b, i) { b.classList.toggle('is-on', i === k); }); });
      }, { passive: true });
    }
    return gal;
  }
  function jump(row, x) { try { row.scrollTo({ left: x, top: 0, behavior: 'instant' }); } catch (e) { row.scrollLeft = x; } }
  // A design's photo, at once: the gallery moves to the color slide, the design's small photo (the swatch she tapped,
  // already loaded) fills it, and the large photo fades in over it when it is in. No blank frame, no wait.
  function photoTo(v, move) {
    var row = q(dlg, '[data-qv-row]'), cs = row && q(row, '[data-qv-cslide]');
    if (!row || !cs || !v || !v.l) return;
    var img = q(cs, 'img'), i = Array.prototype.indexOf.call(row.children, cs), want = fit(v.l), mid = sized(v.l, 540);
    if (move) jump(row, i * row.clientWidth);
    if (img.getAttribute('src') === want) return;
    // pass 67: the photo she asked for at once: the sharp file when it was read ahead, else the medium one read ahead
    // at the opening (or the swatch's own small photo), with the sharp file fading in over it.
    var ph = have(mid) ? mid : (v.th || '');
    cs.style.backgroundSize = have(mid) ? 'contain' : '';
    if (ph) cs.style.backgroundImage = 'url("' + String(ph).replace(/"/g, '%22') + '")';
    var ct = q(dlg, '[data-qv-cthumb] img'); if (ct && v.th) ct.src = v.th;
    if (have(want)) { img.removeAttribute('srcset'); img.src = want; img.classList.add('is-in'); return; }
    img.classList.remove('is-in');
    img.removeAttribute('srcset');
    // The photo she asked for goes first: the photos read ahead wait until it is in (at most 2.5 s).
    window.__mbQvHold = true;
    var rel = function () { window.__mbQvHold = false; };
    img.addEventListener('load', rel, { once: true }); img.addEventListener('error', rel, { once: true }); setTimeout(rel, 2500);
    img.src = want;
    if (img.complete && img.naturalWidth) { img.classList.add('is-in'); rel(); }
  }
  function optBlock(d, i) {
    var o = d.opts[i], k = optKind(d, i), box = el('div', 'mbqv__opt');
    box.setAttribute('data-qv-opt', String(i));
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', o.n);
    box.appendChild(el('p', 'mbqv__optl', esc(o.n) + ': <span data-qv-optv></span>'));
    var wrap = el('div', k === 'photo' ? 'mbqv__sws' : k === 'chip' ? 'mbqv__chips' : 'mbqv__txs');
    o.v.forEach(function (val) {
      var b = el('button', k === 'photo' ? 'mbqv__sw' : k === 'chip' ? 'mbqv__chip' : 'mbqv__tx');
      b.type = 'button';
      b.setAttribute('data-qv-i', String(i));
      b.setAttribute('data-qv-v', val);
      if (k === 'photo') {
        var th = ''; d.vars.forEach(function (v) { if (!th && v.o[i] === val && v.th) th = v.th; });
        b.innerHTML = '<span class="mbqv__swp"><img src="' + esc(th) + '" alt="" width="80" height="80" loading="' + (o.v.indexOf(val) < 15 ? 'eager' : 'lazy') + '" decoding="async"></span><span class="mbqv__swn">' + esc(val) + '</span>';
      } else if (k === 'chip') {
        b.style.setProperty('--c', HEX[val] || '#D9D2C3');
        b.title = val;
      } else {
        var m = String(val).match(/^(\d+(?:\.\d+)?\s?mm)\s+(.+)$/);
        // pass 71: a choice with a bracket ("21 in (54 cm)", the mats) reads "21 in" over "54 cm", never broken inside it
        var m2 = !m && String(val).match(/^(.+?)\s*\((.+)\)$/);
        b.innerHTML = m ? '<span class="mbqv__txn">' + esc(m[2]) + '</span><span class="mbqv__txm">' + esc(m[1]) + '</span>' : m2 ? '<span class="mbqv__txn">' + esc(m2[1]) + '</span><span class="mbqv__txm">' + esc(m2[2]) + '</span>' : '<span class="mbqv__txn">' + esc(val) + '</span>';
      }
      wrap.appendChild(b);
    });
    box.appendChild(wrap);
    return box;
  }
  function fields(d) {
    var c = st.c, k = st.kind, mode = c.mode, f = el('div', 'mbqv__flds');
    if (mode !== 'add' && mode !== 'card') return null;
    if (k === 'pz') {
      var z = PZ[d.tpl];
      f.innerHTML = '<label class="mbqv__f"><span class="mbqv__fl">Personalization</span><input type="text" class="mbqv__in" data-qv-pz maxlength="120" autocomplete="off" autocapitalize="words" autocorrect="off" spellcheck="false" enterkeyhint="done" placeholder="' + esc(z.ph) + '"><span class="mbqv__hint">' + esc(z.hint) + '</span></label>' +
        '<label class="mbqv__tick"><input type="checkbox" data-qv-tick value="' + esc(TICK_PZ) + '"><span>' + esc(TICK_PZ) + '</span></label><p class="mbqv__ferr" data-qv-ferr role="alert" hidden></p>';
      q(f, '[data-qv-pz]').value = c.pz || '';
      q(f, '[data-qv-tick]').checked = !!(c.pz && c.tick);
      return f;
    }
    if (k === 'namebag') {
      f.innerHTML = '<label class="mbqv__f"><span class="mbqv__fl">Name on the bag</span><span class="mbqv__inw"><input type="text" class="mbqv__in mbqv__in--cnt" data-qv-name maxlength="20" autocomplete="off" autocapitalize="words" autocorrect="off" spellcheck="false" enterkeyhint="done"><span class="mbqv__cnt" data-qv-cnt aria-hidden="true">0/20</span></span></label>' +
        '<label class="mbqv__tick"><input type="checkbox" data-qv-tick value="' + esc(TICK_BAG) + '"><span>' + esc(TICK_BAG) + '</span></label><p class="mbqv__ferr" data-qv-ferr role="alert" hidden></p>';
      var ni = q(f, '[data-qv-name]'); ni.value = c.bagName || ''; q(f, '[data-qv-cnt]').textContent = ni.value.length + '/20';
      q(f, '[data-qv-tick]').checked = !!(c.bagName && c.tick);
      return f;
    }
    if (k === 'acc') {
      var has0 = !!(c.note && c.note.trim());
      f.innerHTML = '<button type="button" class="mbqv__nt" data-qv-nt aria-expanded="' + (has0 ? 'true' : 'false') + '"' + (has0 ? ' hidden' : '') + '>Add a note</button><input type="text" class="mbqv__in" data-qv-note maxlength="80" autocomplete="off" enterkeyhint="done" placeholder="Your note" aria-label="Note"' + (has0 ? '' : ' hidden') + '>';
      q(f, '[data-qv-note]').value = c.note || '';
      return f;
    }
    return null;
  }
  // Everything that follows the choice: the pressed buttons, the names, the price, the photo, the button.
  function paint(move) {
    var d = st.d, c = st.c, v = cur();
    qa(dlg, '[data-qv-i]').forEach(function (b) {
      var i = Number(b.getAttribute('data-qv-i')), val = b.getAttribute('data-qv-v'), on = st.sel[i] === val, can = anyAvail(d, i, val);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.disabled = !can;
      var nm = val + (can ? '' : ', sold out');
      b.setAttribute('aria-label', nm);
      if (b.classList.contains('mbqv__sw')) {
        var so = q(b, '.mbqv__swo');
        if (!can && !so) b.insertAdjacentHTML('beforeend', '<span class="mbqv__swo">Sold out</span>');
        if (can && so) so.remove();
      }
    });
    qa(dlg, '[data-qv-opt]').forEach(function (box) { var i = Number(box.getAttribute('data-qv-opt')), s = q(box, '[data-qv-optv]'); if (s) s.textContent = st.sel[i] || ''; });
    var pr = q(dlg, '.mbqv__pr'), now = v ? v.p : 0, was = v && v.c > v.p ? v.c : 0;
    if ((c.mode === 'two' || c.mode === 'pick2') && c.off > 0 && v && v.p > c.off) { was = v.p; now = v.p - c.off; }
    st.now = now;
    if (pr) {
      pr.innerHTML = (c.mode === 'tick' ? '+' : '') + money(now) + (was ? ' <s><span class="mbqv__sr">Regular price </span>' + money(was) + '</s>' : '') + (st.fix ? '<span class="mbqv__sz">' + esc(st.fix.v) + '</span>' : '');
    }
    if (v) photoTo(v, move);
    var go = q(dlg, '[data-qv-go]');
    if (!go) return;
    go.removeAttribute('data-qv-retry');
    var ok = !!(v && v.a && okFix(v));
    go.disabled = !ok || st.done;
    if (st.done) return;
    if (!ok) { go.textContent = 'Sold out'; return; }
    // The price on the button is left out on a very narrow phone (under 360 px), where it would take a second line.
    var lab = esc(c.label || 'Add to cart'), gp = function (x) { return '<span class="mbqv__gop"> · ' + x + '</span>'; };
    if (c.mode === 'add' || c.mode === 'card') lab = 'Add to cart' + gp(money(now * st.qty));
    else if (c.mode === 'pick2') lab = esc(c.label || 'Add this set') + gp(money(now));
    else if (c.mode === 'tick') lab = esc(c.label || 'Add with your set') + gp('+' + money(now));
    go.innerHTML = '<span>' + lab + '</span>';
    var qd = q(dlg, '[data-qv-q="-1"]'); if (qd) qd.disabled = st.qty <= 1;
    var qu = q(dlg, '[data-qv-q="1"]'); if (qu) qu.disabled = st.qty >= 10;
    var qn = q(dlg, '[data-qv-qn]'); if (qn) qn.textContent = String(st.qty);
  }

  // ---------- taps inside ----------
  function inside(e) {
    var t = e.target;
    if (closing) { e.preventDefault(); return; }
    if (t === dlg) { close('out'); return; }
    if (t.closest('[data-qv-x]')) { e.preventDefault(); close('x'); return; }
    var b = t.closest('[data-qv-i]');
    if (b) { e.preventDefault(); if (b.disabled || !st.d) return; var i = Number(b.getAttribute('data-qv-i')), v = resolve(st.d, i, b.getAttribute('data-qv-v')); if (v) { st.sel = v.o.slice(); if (st.fix) st.sel[st.fix.i] = st.fix.v; } errOff(); paint(true); return; }
    var tb = t.closest('[data-qv-thumb]');
    if (tb) { e.preventDefault(); var rw = q(dlg, '[data-qv-row]'); if (rw) jump(rw, Number(tb.getAttribute('data-qv-thumb')) * rw.clientWidth); return; }
    var sp = t.closest('[data-qv-step]');
    if (sp) { e.preventDefault(); var row = q(dlg, '[data-qv-row]'); if (row) row.scrollBy({ left: Number(sp.getAttribute('data-qv-step')) * row.clientWidth, behavior: calm() ? 'auto' : 'smooth' }); return; }
    var nt = t.closest('[data-qv-nt]');
    if (nt) { e.preventDefault(); var ni = q(dlg, '[data-qv-note]'); nt.hidden = true; nt.setAttribute('aria-expanded', 'true'); if (ni) { ni.hidden = false; try { ni.focus(); } catch (x) {} } return; }
    var qb = t.closest('[data-qv-q]');
    if (qb) { e.preventDefault(); if (qb.disabled) return; st.qty = Math.max(1, Math.min(10, st.qty + Number(qb.getAttribute('data-qv-q')))); paint(false); return; }
    var go = t.closest('[data-qv-go]');
    if (go) { e.preventDefault(); if (go.hasAttribute('data-qv-retry')) { var c = st.c; closeNow(); setTimeout(function () { open(c); }, 0); return; } act(go); return; }
    // No link inside the pop-up loads a page (the description is printed without links; this is the guard).
    var a = t.closest('a[href]');
    if (a && !/^(mailto|tel|sms):/i.test(a.getAttribute('href') || '')) e.preventDefault();
  }
  function field(e) {
    var t = e.target;
    if (!t || !t.hasAttribute) return;
    if (t.hasAttribute('data-qv-name') && e.type === 'input') {
      var c = q(dlg, '[data-qv-cnt]'); if (c) c.textContent = t.value.length + '/20';
      var k = q(dlg, '[data-qv-tick]'); if (k && k.checked) k.checked = false;
      t.removeAttribute('aria-invalid'); errOff();
    }
    if (t.hasAttribute('data-qv-pz') && e.type === 'input') {
      var k2 = q(dlg, '[data-qv-tick]'); if (k2 && k2.checked) k2.checked = false;
      t.removeAttribute('aria-invalid'); errOff();
    }
    if (t.hasAttribute('data-qv-tick') && t.checked) errOff();
  }
  function errOff() { qa(dlg, '[data-qv-ferr], [data-qv-err]').forEach(function (x) { x.hidden = true; x.textContent = ''; }); }
  function bad(text, input) {
    var fe = q(dlg, '[data-qv-ferr]'), be = q(dlg, '[data-qv-err]');
    if (fe) { fe.textContent = text; fe.hidden = false; }
    if (be) { be.textContent = text; be.hidden = false; }
    if (input) {
      if (input.type !== 'checkbox') input.setAttribute('aria-invalid', 'true');
      try { input.focus({ preventScroll: true }); } catch (x) {}
      try { input.scrollIntoView({ block: 'center', behavior: calm() ? 'auto' : 'smooth' }); } catch (x) {}
    }
    live(text);
  }
  // The line item properties, as the product page and the shelf card send them. Null: a required field is missing.
  function props() {
    var k = st.kind, p = {};
    if (k === 'pz') {
      var z = q(dlg, '[data-qv-pz]'), tk = q(dlg, '[data-qv-tick]');
      if (!z.value.trim()) { bad('Please type the words to print.', z); return null; }
      if (!tk.checked) { bad('Please tick the box to confirm the spelling.', tk); return null; }
      p['Personalization'] = z.value.trim(); p['Spelling checked'] = tk.value;
    } else if (k === 'namebag') {
      var ne = q(dlg, '[data-qv-name]'), tk2 = q(dlg, '[data-qv-tick]'), nm = ne.value.trim();
      if (!nm || nm.length > 20) { bad('Please type the name to stitch.', ne); return null; }
      var re; try { re = new RegExp("^[\\p{L}\\p{M}\\p{N} &'\\u2019.\\-]+$", 'u'); } catch (x) { re = /^[A-Za-zÀ-ɏ0-9 &'’.\-]+$/; }
      if (!re.test(nm)) { bad('Letters, numbers and spaces only.', ne); return null; }
      if (!tk2.checked) { bad('Please tick the box to confirm the spelling.', tk2); return null; }
      p['Name to stitch'] = nm; p['Spelling checked'] = tk2.value;
    } else if (k === 'plainbag') {
      p['Stitching'] = 'None, plain bag';
    } else if (k === 'acc') {
      var no = q(dlg, '[data-qv-note]'), nv = no ? no.value.trim() : '';
      if (nv) p['Note'] = nv;
    }
    return p;
  }

  // ---------- the button ----------
  function act(go) {
    var c = st.c, v = cur();
    if (busy || st.done || !v || !v.a) return;
    errOff();
    if (c.mode === 'tick') return doTick(v);
    if (c.mode === 'two') return doTwo(v);
    var p = props();
    if (!p) return;
    var item = { id: v.id, quantity: c.mode === 'pick2' ? 1 : st.qty };
    if (Object.keys(p).length) item.properties = p;
    addLine(item, go);
  }
  function secIds() {
    var a = [];
    (window.__mbCartDraw ? ['cart-drawer-component'] : ['cart-drawer-component', 'cart-icon']).forEach(function (n) { var e = doc.querySelector(n), s = e && e.closest('.shopify-section'); if (s && s.id && a.indexOf(s.id) < 0) a.push(s.id); });
    return a.map(function (x) { return x.replace(/^shopify-section-/, ''); });
  }
  function secHtml(j) { var s = j && j.sections, a = secIds(), h = ''; if (!s || !a.length) return ''; for (var i = 0; i < a.length; i++) { if (typeof s[a[i]] !== 'string') return ''; h += s[a[i]]; } return h; }
  function addLine(item, go) {
    var c = st.c, onCart = location.pathname === cartPath, body = { items: [item] }, ids = secIds();
    if (!onCart && ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
    busy = true;
    go.setAttribute('aria-busy', 'true');
    go.textContent = 'Adding…';
    fetch(root0 + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) { var m = (x.j && (x.j.description || x.j.message)) || ''; throw { m: typeof m === 'string' ? m : '' }; }
        var line = x.j && x.j.items && x.j.items[0];
        busy = false;
        st.done = true;
        go.removeAttribute('aria-busy');
        go.classList.add('is-done');
        go.innerHTML = ICON_OK + '<span>Added</span>';
        go.disabled = true;
        live((st.d.hd || 'It') + ' is in your cart.');
        // The cart, drawn in place: the cart page on the cart page, the drawer anywhere else (snippets/mb-cart-fix).
        var drawn = null;
        if (onCart) {
          drawn = fetch(cartPath, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } }).then(function (p) { return p.ok ? p.text() : ''; })
            .then(function (h) { if (h && window.__mbCartPage) return window.__mbCartPage(h, {}); if (h) { location.reload(); } return true; });
        } else if (window.__mbCartDraw) drawn = window.__mbCartDraw(secHtml(x.j), {});
        try { doc.dispatchEvent(new CustomEvent('mbqv:added', { detail: { card: c.r, line: line, mode: c.mode } })); } catch (e) {}
        Promise.resolve(drawn).catch(function () {}).then(function () { setTimeout(function () { if (st && st.done) close('done'); }, 650); });
      })
      .catch(function (er) {
        busy = false;
        go.removeAttribute('aria-busy');
        paint(false);
        bad((er && er.m) || 'We could not add this. Please try again.', null);
      });
  }
  // The box Extras: the tick takes the design she chose; no cart line of its own (the set page sends it with the set).
  var picks = {};
  function tickRow(lb, v, d) {
    var inp = q(lb, 'input[data-mbo-dice], input[data-mbo-trink]');
    if (!inp) return;
    var base = String(inp.getAttribute('data-qv-base') || inp.getAttribute('data-n') || '').split(' · ')[0];
    if (!inp.hasAttribute('data-qv-base')) inp.setAttribute('data-qv-base', base);
    var name = isDefault(d) ? base : base + ' · ' + v.t;
    inp.setAttribute('data-id', String(v.id));
    inp.setAttribute('data-c', String(v.p));
    inp.setAttribute('data-n', name);
    var nm = q(lb, '.mbo__optname'); if (nm) nm.textContent = name;
    var im = q(lb, '.mbo__optimg'); if (im && v.th) { im.removeAttribute('srcset'); im.src = sized(v.th, 132).replace(/height=\d+/, 'height=132'); }
    var pr = q(lb, '.mbo__optprice');
    if (pr) pr.innerHTML = '+' + money(v.p) + (v.c > v.p ? '<s class="mbo__was"><span class="visually-hidden">Regular price </span>' + money(v.c) + '</s>' : '');
    inp.setAttribute('data-qv-vid', String(v.id));
  }
  function doTick(v) {
    var c = st.c, d = st.d, lb = c.r, inp = c.inp || q(lb, 'input');
    var kind = inp && inp.hasAttribute('data-mbo-dice') ? 'dice' : 'trink';
    picks[kind] = { h: c.h, v: v, d: d };
    watch();
    tickRow(lb, v, d);
    st.done = true;
    close('done', function () {
      if (!inp || !inp.isConnected) return;
      if (!inp.checked) inp.click();
      else inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  // The theme draws the box again when she picks another size or color on the page; the tick keeps her design.
  function reTick() {
    Object.keys(picks).forEach(function (k) {
      var pk = picks[k], inp = doc.querySelector(k === 'dice' ? 'input[data-mbo-dice]' : 'input[data-mbo-trink]');
      var lb = inp && inp.closest('label[data-qv]');
      if (!lb || lb.getAttribute('data-qv') !== pk.h || inp.getAttribute('data-qv-vid') === String(pk.v.id)) return;
      tickRow(lb, pk.v, pk.d);
    });
  }
  var mo = null;
  function watch() {
    if (mo || !window.MutationObserver) return;
    var raf = 0;
    mo = new MutationObserver(function () { if (raf || !Object.keys(picks).length) return; raf = requestAnimationFrame(function () { raf = 0; reTick(); }); });
    mo.observe(doc.body, { childList: true, subtree: true });
  }
  // "A second set" on a tile set page: the same event as the "Add as a second set" of pass 62 (blocks/mb-offer-selector).
  function doTwo(v) {
    var c = st.c, d = st.d, bi = -1;
    d.opts.forEach(function (o, i) { if (/back colou?r/i.test(o.n)) bi = i; });
    var col = bi >= 0 ? v.o[bi] : '';
    st.done = true;
    close('done', function () {
      var ev = new CustomEvent('mbs:do', { cancelable: true, detail: { name: 'two', value: c.h, color: col } });
      doc.dispatchEvent(ev);
    });
  }

  // ---------- close ----------
  var after = null;
  function close(why, fn) {
    if (!dlg || !dlg.open || closing) { if (fn) fn(); return; }
    after = fn || null;
    if (pushed) { pushed = false; hback(); }
    if (calm()) { closeNow(); return; }
    closing = true;
    dlg.classList.add('is-out');
    var t = setTimeout(fin, 220);
    function fin() { clearTimeout(t); dlg.removeEventListener('animationend', onEnd); closing = false; closeNow(); }
    function onEnd(e) { if (e.target === dlg) fin(); }
    dlg.addEventListener('animationend', onEnd);
  }
  function closeNow() { if (dlg && dlg.open) dlg.close(); else cleanup(); }
  function cleanup() {
    closing = false;
    if (dlg) dlg.classList.remove('is-out');
    unlock();
    if (pushed) { pushed = false; hback(); }
    var fn = after; after = null;
    var b = dlg && q(dlg, '[data-qv-body]'); if (b) b.innerHTML = '';
    st = null; busy = false;
    if (fn) { if (popWait) popWait.then(fn); else fn(); }
  }

  // ---------- history: the back gesture closes the pop-up, never the page ----------
  function hpush() {
    try { history.pushState({ mbqv: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
  }
  function hback() {
    var done = null;
    popWait = new Promise(function (res) { done = res; });
    var t = setTimeout(function () { finish(); }, 600);
    function finish() { clearTimeout(t); window.removeEventListener('popstate', onPop, true); var p = popWait; popWait = null; done(); return p; }
    function onPop() { finish(); }
    window.addEventListener('popstate', onPop, true);
    try { history.back(); } catch (e) { finish(); }
  }
  window.addEventListener('popstate', function () {
    if (popWait) return;
    if (dlg && dlg.open && pushed && !(history.state && history.state.mbqv)) { pushed = false; close('back'); }
  });

  // ---------- the page behind does not scroll ----------
  function lock() {
    if (lk) return;
    var h = doc.documentElement, w = window.innerWidth - h.clientWidth;
    lk = { o: h.style.overflow, p: h.style.paddingRight, y: window.scrollY, set: false };
    if (getComputedStyle(h).overflow !== 'hidden' && !h.hasAttribute('scroll-lock')) { h.style.overflow = 'hidden'; if (w > 0) h.style.paddingRight = w + 'px'; lk.set = true; }
  }
  function unlock() {
    if (!lk) return;
    var h = doc.documentElement, y = lk.y;
    if (lk.set) { h.style.overflow = lk.o; h.style.paddingRight = lk.p; if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y); }
    lk = null;
  }

  // pass 75: the Add buttons of the "You may also like" set cards are printed hidden (a page without this script shows
  // the card as a plain link); with the pop-up they show.
  function adds() { qa(doc, 'button.mbal__add[data-qv-add][hidden]').forEach(function (b) { b.hidden = false; }); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', adds); else adds();

  // ---------- taps on the page ----------
  window.addEventListener('click', function (e) {
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var f = find(e.target);
    if (!f || f.r.__qvBack) return;
    e.preventDefault();
    e.stopPropagation();
    open(ctxOf(f));
  }, true);
  function pre(e) { var f = find(e.target); if (f) load(f.r.getAttribute('data-qv')).catch(function () {}); }
  window.addEventListener('pointerdown', pre, { capture: true, passive: true });
  // On a computer, a photo or name the mouse rests on for 0.2 s is read before the click; ten at most per page, so a
  // mouse that sweeps over a list never sends a burst (a tap reads at once, on pointerdown).
  var hov = 0, nHov = 0;
  window.addEventListener('mouseover', function (e) {
    if (nHov >= 10 || !(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    clearTimeout(hov);
    var t = e.target;
    hov = setTimeout(function () { var f = find(t), h = f && f.r.getAttribute('data-qv'); if (!h || cache[h]) return; nHov++; load(h).catch(function () {}); }, 200);
  }, { passive: true });
  // The photo of a card is a button for a keyboard too.
  function kb() {
    qa(doc, '.mbsl__card[data-qv] .mbsl__ph, .mbcs__card[data-qv] .mbcs__ph').forEach(function (p) {
      if (p.hasAttribute('tabindex')) return;
      var r = p.closest('[data-qv]'), n = r ? txt(q(r, '.mbsl__name, .mbcs__n')) : '';
      p.setAttribute('role', 'button'); p.setAttribute('tabindex', '0'); p.setAttribute('aria-label', 'See ' + (n || 'this product'));
    });
  }
  doc.addEventListener('keydown', function (e) {
    if ((e.key !== 'Enter' && e.key !== ' ') || !e.target || !e.target.matches || !e.target.matches('[data-qv] .mbsl__ph[role="button"], [data-qv] .mbcs__ph[role="button"]')) return;
    var f = find(e.target);
    if (!f) return;
    e.preventDefault();
    open(ctxOf(f));
  }, true);
  doc.addEventListener('focusin', function (e) { var t = e.target; if (t && t.closest && (t.closest('[data-qv]') || t.closest('dialog')) && !t.closest('#mb-qv')) kb(); });
  QV.open = function (h, o) { o = o || {}; open({ r: o.r || doc.body, o: null, mode: o.mode || 'add', h: h, vid: o.vid || 0, img: o.img || '', name: o.name || '', label: o.label || '' }); };
})();
